import request from "@/utils/request";

// 获取公司信息
export function queryCompanyInfo(deptId) {
  return request({
    url: `/opCompanyBaseInfo/getInfoByDeptId/${deptId}`,
    method: "get",
  });
}

// 新增公司信息
export function insertCompanyInfo(data) {
  return request({
    url: "/opCompanyBaseInfo/save",
    method: "post",
    data,
  });
}

// 编辑公司信息
export function updateCompanyInfo(data) {
  return request({
    url: "/opCompanyBaseInfo/update",
    method: "post",
    data,
  });
}

// 股权架构分页查询
export function queryCompanyStock(data) {
  return request({
    url: "/opCompanyShareholdingStructure/page",
    method: "post",
    data,
  });
}

// 股权架构新增
export function insertCompanyStock(data) {
  return request({
    url: "/opCompanyShareholdingStructure/save",
    method: "post",
    data,
  });
}

// 股权架构编辑
export function updateCompanyStock(data) {
  return request({
    url: "/opCompanyShareholdingStructure/update",
    method: "post",
    data,
  });
}

// 删除股权架构
export function deleteCompanyStock(id) {
  return request({
    url: `/opCompanyShareholdingStructure/delete/${id}`,
    method: "delete",
  });
}

// 公司证件列表
export function queryCompanyCertificates(data) {
  return request({
    url: `/opCompanyBaseCertificate/page`,
    method: "post",
    data,
  });
}

// 新增证件
export function insertCompanyCertificate(data) {
  return request({
    url: "/opCompanyBaseCertificate/save",
    method: "post",
    data,
  });
}

// 修改证件
export function updateCompanyCertificate(data) {
  return request({
    url: "/opCompanyBaseCertificate/update",
    method: "post",
    data,
  });
}

// 删除证件
export function deleteCompanyCertificate(id) {
  return request({
    url: `/opCompanyBaseCertificate/delete/${id}`,
    method: "delete",
  });
}

// 获取合同列表
export function queryCompanyContracts(data) {
  return request({
    url: `/opCompanyContract/page`,
    method: "post",
    data,
  });
}

// 新增公司合同
export function insertCompanyContract(data) {
  return request({
    url: "/opCompanyContract/save",
    method: "post",
    data,
  });
}

// 编辑公司合同
export function updateCompanyContract(data) {
  return request({
    url: "/opCompanyContract/update",
    method: "post",
    data,
  });
}
// 删除合同
export function deleteCompanyContract(id) {
  return request({
    url: `/opCompanyContract/delete/${id}`,
    method: "delete",
  });
}
// 获取公司下的厂站
export function queryStationListByDeptId(orgId) {
  return request({
    url: `/opCompanyContract/getOrgListByParentId/${orgId}`,
    method: "get",
  });
}

// 获取公司下的厂站的基本信息
export function queryStationInfoByOrgId(orgId) {
  return request({
    url: `/opCompanyBaseInfo/getBaseInfoListByOrgId/${orgId}`,
    method: "get",
  });
}

// 获取组织架构
export function queryOrgTree(deptId) {
  return request({
    url: `/opPlantsFlowChart/selectTree/${deptId}`,
    method: "post",
  });
}
